import { atomWithImmer } from 'jotai-immer';

import { TableSortingType } from './tableSortingStore.types.js';

export const tableSortingStore = atomWithImmer<TableSortingType>({ field: '' });
